import { createRouter, createWebHistory } from 'vue-router';
import ForgotPasswordPage from '@/views/main/ForgotPasswordPage.vue';
import LoginPage from '@/views/main/LoginPage.vue';
import MainOperacionalPage from '@/views/main/MainOperacionalPage.vue';
import ResetPasswordPage from '@/views/main/ResetPasswordPage.vue';
// import WelcomePage from '@/views/main/WelcomePage.vue';

const routes = [
    // { path: '/', name: 'WelcomePage', component: WelcomePage },
    { path: '/', name: 'LoginPage', component: LoginPage },
    { path: '/forgot-password', name: 'ForgotPasswordPage', component: ForgotPasswordPage },
    { path: '/login', name: 'LoginPageLogout', component: LoginPage },
    { path: '/operacional', name: 'MainOperacionalPage', component: MainOperacionalPage },
    { path: '/reset-password', name: 'ResetPasswordPage', component: ResetPasswordPage },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
